// src/modules/app-views/invoices/pages/Init/components/tableColumns/items/itemSkuColumn.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Typography } from 'antd';
import { resolveItemFontSize } from './index';

const { Text } = Typography;

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************

// Renders the SKU column for item subtables.
// options.title: column header label key (default: 'SKU' literal, not translated)
// options.size: 'small' (11px, default) | 'middle' (14px)
function itemSkuColumn(options = {}) {
  const { title = 'SKU', size } = options;
  const fontSize = resolveItemFontSize(size, 11);

  return {
    title,
    dataIndex: ['product', 'sku'],
    width: 80,
    ellipsis: true,
    sorter: (a, b) => {
      const aVal = a?.product?.sku || a?.sku || a?.productCode || '';
      const bVal = b?.product?.sku || b?.sku || b?.productCode || '';
      return aVal.localeCompare(bVal);
    },
    render: (_, item) => (
      <Text style={{ fontSize }}>
        {item?.product?.sku || item?.sku || item?.productCode || '—'}
      </Text>
    ),
  };
}

export default itemSkuColumn;
